import {ArchivingPanel, DemandAdditionalInfo, DemandPlanRealizationPanel, FinishDemandPanel, FinishDocumentsPanel, ResultNoticePanel} from "./panels";
import ResultNoticeService from "services/ResultNoticeService";
import FinishDemandService from "services/FinishDemandService";
import ArchivingService from "services/ArchivingService";
import DemandPlanRealizationService from "services/DemandPlanRealizationService";
import DemandAdditionalInfoService from "services/DemandAdditionalInfoService";
import {DemandValidation} from "constants/DemandValidation";

export default {
    mp_4_result_notice: ResultNoticePanel,
    mp_4_finish_documents: FinishDocumentsPanel,
    mp_4_demand_plan_realization: DemandPlanRealizationPanel,
    mp_4_finish_demand: FinishDemandPanel,
    mp_4_archiving: ArchivingPanel,
    mp_4_finish_additional_info: DemandAdditionalInfo,
}

export const panelsValidationKeys = {
    mp_4_result_notice: (id) => ResultNoticeService.validate(id),
    mp_4_finish_documents: (id) => null,
    mp_4_demand_plan_realization: (id) => DemandPlanRealizationService.validate(id),
    mp_4_finish_demand: (id) => FinishDemandService.validate(id),
    mp_4_archiving: (id) => ArchivingService.validate(id),
    mp_4_finish_additional_info: (id) => DemandAdditionalInfoService.validate(id, DemandValidation.FINISH_ADDITIONAL_INFO),
}